(function() {
  // Temporary redirect for consolidated Cloak Belt Holster pages
  const currentPath = window.location.pathname;
  const newUrl = '/products/cloak-belt-holster';

  // Match patterns: /products/cloak-belt-holster-for-*, /products/cloak-belt-for-*
  // and general wildcard patterns: /products/cloak-belt-holster-*, /products/cloak-belt-*
  const redirectPatterns = [
    /^\/products\/cloak-belt-holster-for-.+$/i,
    /^\/products\/cloak-belt-for-.+$/i,
    /^\/products\/cloak-belt-holster-.+$/i,
    /^\/products\/cloak-belt-.+$/i
  ];

  // Check if current URL matches any redirect pattern
  const shouldRedirect = redirectPatterns.some(pattern => pattern.test(currentPath));

  if (shouldRedirect && currentPath !== newUrl) {
    window.location.replace(newUrl);
  }
})();
